import { Avatar, Box, Table, Text } from '@factorialco/deprecated-design-system'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import buildUrl from 'modules/core/lib/buildUrl'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'

interface Props {
  selectedEmployees: EmployeeForSelectFragmentNoAccess[] | undefined
  handleSelectEmployees: (newEmployees: EmployeeForSelectFragmentNoAccess[]) => void
}

export const BankAccountMembershipSelector = ({
  selectedEmployees,
  handleSelectEmployees,
}: Props) => {
  return (
    <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s8">
      <EmployeeSelector
        value={selectedEmployees || []}
        onSelect={handleSelectEmployees}
        hideSearchIcon
        multiple
      />

      {selectedEmployees && selectedEmployees.length > 0 && (
        <Table autoLayout>
          <Table.Head>
            <Table.Row>
              <Table.HeadCell>Employees</Table.HeadCell>
            </Table.Row>
          </Table.Head>
          {selectedEmployees.map((employee) => (
            <Table.Row key={`employee-${employee.id}`}>
              <Table.Cell noBorder width={108} paddingX="s4">
                <Box style={{ paddingLeft: '20px' }}>
                  <Box flexDirection="row" alignItems="center" gap="s16">
                    <Avatar
                      label={employee.fullName}
                      url={buildUrl(employee.access?.avatar)}
                      size="s40"
                    />
                    <Text.Normal>{employee.fullName}</Text.Normal>
                  </Box>
                </Box>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table>
      )}
    </Box>
  )
}
